import Vue from "vue";

const getDefaultState = () => {
  return {
    currentTab: null,

    integrations: {
      googleCalendar: false,
    },

    emailPreferences: {},
    emailPreferencesLoaded: false,
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  setTab(tab) {
    state.currentTab = tab;
  },

  setIntegrationState(integration, newState) {
    state.integrations[integration] = newState;
  },

  setEmailPreferencesLoaded(){
    state.emailPreferencesLoaded = true;
  },

  setEmailPreferences(emailPreferences) {
    state.emailPreferences = emailPreferences;
  },

  updateEmailPreference(type, newValue) {
    state.emailPreferences[type] = newValue;
  },
};

const SpaceStore = {
  state,
  methods,
};
export default SpaceStore;
